import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Ho4ArticleSidebar from '../components/Ho4ArticleSidebar';
import { HO4_LAST_MODIFIED } from '../data/ho4Articles';

function Ho4CollegeStudentsTexasArticlePage() {
  const navigate = useNavigate();
  const articleLinkStyle = { color: '#065F46', fontWeight: 600, textDecoration: 'underline' };

  useEffect(() => {
    const previousTitle = document.title;
    const descriptionMeta = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionMeta?.getAttribute('content') ?? '';
    document.title = 'HO-4 for College Students in Texas | GetSkimp';
    if (descriptionMeta) {
      descriptionMeta.setAttribute(
        'content',
        'Learn how Texas college students can choose HO-4 renters insurance for apartments and off-campus housing.'
      );
    }
    return () => {
      document.title = previousTitle;
      if (descriptionMeta) descriptionMeta.setAttribute('content', previousDescription);
    };
  }, []);

  return (
    <div className="container">
      <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: '2rem' }}>
        <Ho4ArticleSidebar
          activeHref="/knowledge-base/ho4-for-college-students-in-texas"
          onNavigate={(href) => navigate(href)}
        />
        <section>
          <div style={{ marginBottom: '1rem' }}>
            <button type="button" className="btn btn-sm btn-outline" onClick={() => navigate('/knowledge-base')} style={{ marginBottom: '1rem' }}>
              Back to self help library
            </button>
            <h2 style={{ marginBottom: '0.5rem' }}>HO-4 for college students in Texas</h2>
            <p style={{ marginBottom: 0, color: '#4B5563' }}>A student-friendly checklist for off-campus renters in Texas.</p>
            <p style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: '#6B7280' }}>Last modified: {HO4_LAST_MODIFIED}</p>
          </div>

          <article className="card mb-4">
            <div className="card-body">
              <h3 style={{ marginBottom: '0.75rem' }}>Quick answer</h3>
              <p>
                If you rent off-campus, HO-4 can protect your belongings and liability exposure at a student-friendly
                price point. Many leases require proof of coverage.
              </p>
              <h3 style={{ marginBottom: '0.75rem', marginTop: '1.5rem' }}>Student checklist</h3>
              <ul style={{ paddingLeft: '1.2rem', marginBottom: 0 }}>
                <li style={{ marginBottom: '0.5rem' }}>Check lease insurance requirements before move-in.</li>
                <li style={{ marginBottom: '0.5rem' }}>Estimate replacement value for laptop, phone, and essentials.</li>
                <li style={{ marginBottom: '0.5rem' }}>Pick a liability limit that meets lease terms.</li>
                <li>Confirm whether roommates need separate policies.</li>
              </ul>
              <p style={{ marginTop: '1rem', marginBottom: 0 }}>
                Start with{' '}
                <Link to="/knowledge-base/what-is-ho4-renters-insurance" style={articleLinkStyle}>
                  HO-4 basics
                </Link>{' '}
                then review{' '}
                <Link to="/knowledge-base/is-ho4-required-by-landlord" style={articleLinkStyle}>
                  landlord requirements
                </Link>{' '}
                and{' '}
                <Link to="/knowledge-base/does-ho4-cover-roommates" style={articleLinkStyle}>
                  roommate coverage
                </Link>
                .
              </p>
            </div>
          </article>

          <section className="card mb-4" style={{ borderColor: 'var(--color-green)', background: 'linear-gradient(135deg, #ECFDF5 0%, #FFFFFF 100%)', boxShadow: 'var(--shadow-md)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#065F46' }}>Start renters insurance with GetSkimp</h3>
              <p style={{ marginBottom: '1rem' }}>Get coverage ready before classes and move-in deadlines.</p>
              <button type="button" className="btn btn-primary" onClick={() => navigate('/qualify')} style={{ fontWeight: 700, paddingInline: '1.4rem' }}>Get started now</button>
            </div>
          </section>
          <section className="card" style={{ borderColor: '#FBBF24', background: 'linear-gradient(135deg, #FFFBEB 0%, #FFFFFF 100%)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#92400E' }}>Need help as a first-time renter?</h3>
              <p style={{ marginBottom: '1rem' }}>An agent can help you pick limits and avoid common student mistakes.</p>
              <button type="button" className="btn btn-outline" onClick={() => navigate('/help')} style={{ borderColor: '#D97706', color: '#92400E', fontWeight: 700 }}>Speak to an agent</button>
            </div>
          </section>
        </section>
      </div>
    </div>
  );
}

export default Ho4CollegeStudentsTexasArticlePage;

